import React from 'react';

import { pageSizeOptions } from 'components/DesignSystem/Pagination/Pagination.consts';
import { Select } from 'components/DesignSystem/Select';

import { Pagination as DSPagination } from './Pagination';
import styles from './PaginationWithPageSize.module.scss';

export type Pagination = {
    page: number;
    size: number;
};

interface Props {
    totalPages: number;
    pagination: Pagination;
    setPagination: (value: Pagination) => void;
    isDisabled?: boolean;
    showPageSizeOptions?: boolean;
}

export const PaginationWithPageSize = ({
    totalPages,
    pagination,
    setPagination,
    isDisabled = false,
    showPageSizeOptions = true,
}: Props) => {
    return (
        <div className={styles.paginationWithPageSizeContainer}>
            <DSPagination
                count={totalPages}
                siblingCount={2}
                page={pagination.page}
                onChange={(e, value) => setPagination({ ...pagination, page: value })}
                disabled={isDisabled}
            />
            {showPageSizeOptions && (
                <div className={styles.pageSizeSelectContainer}>
                    <Select
                        options={pageSizeOptions}
                        id={'page-size-options'}
                        onChange={(item: ISelectOption<number>) => item && setPagination({ page: 1, size: item.value })}
                        value={pageSizeOptions.find((item) => item.value === pagination.size) || pageSizeOptions[0]}
                        menuPlacement={'top'}
                        isDisabled={isDisabled}
                    />
                </div>
            )}
        </div>
    );
};
